import * as Select from "@radix-ui/react-select"
import React, { forwardRef } from "react"

import { CheckIcon } from "components/SVG"

import * as styles from "./Option.css"
import type { Option } from "./Option.types"

export const DropdownOption = forwardRef<HTMLDivElement, Option>(
  ({ label, value }, forwardedRef) => {
    return (
      <Select.Item
        className={styles.option}
        data-testid="dropdown-option"
        ref={forwardedRef}
        value={value}
      >
        <Select.ItemText>{label}</Select.ItemText>
        <Select.ItemIndicator>
          <CheckIcon role="img" />
        </Select.ItemIndicator>
      </Select.Item>
    )
  }
)
